export const noop = () => undefined;
//# sourceMappingURL=misc.js.map